<template>
    <div class="successPage">
        <div class="page-box">
            <img src="../assets/success-icon.png" alt="">
            <p>支付成功</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "SuccessPage",
    data() {
        return {

        };
    },
    components: {

    },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
.successPage {
    width: 100vw;
    height: 1403px;
    background: url("../assets/active-bg.png");
    background-position: center;
    background-size: cover;
}

.page-box {
    text-align: center;
    padding-top: 200px;

    img {
        width: 200px;
        height: 200px;
    }

    p {
        font-size: 30px;
        font-weight: bold;
        padding-top: 50px;
    }
}
</style>
